import { createFileRoute, useParams } from '@tanstack/react-router';

import { useAuth } from '@/store/auth.ts';
import { CourseAssignmentsView } from '@/views/courses/detail/course-assignments-view.tsx';

// Course-scoped assignments list (filters the role-aware homeworks feed by course).
export const Route = createFileRoute('/_learner/courses_/$id/assignments')({
  component: AssignmentsTab,
});

function AssignmentsTab() {
  const { id } = useParams({ from: '/_learner/courses_/$id/assignments' });
  const user = useAuth((s) => s.user);
  if (!user) return null;
  return <CourseAssignmentsView courseId={id} user={user} />;
}
